var _path, _path2, _path3;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgPaintRoller = function SvgPaintRoller(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 101 119",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M52.782 57.16v-7.399a1.349 1.349 0 0 0-.99-1.297L2.032 35.93A2.693 2.693 0 0 1 0 33.386V14.214a2.696 2.696 0 0 1 2.694-2.695H7.98v3.127H3.075v18.308L54.053 45.82a2.39 2.39 0 0 1 1.804 2.314v9.027h-3.075Z",
    fill: "#0D291C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.98 14.646v9.739a2.544 2.544 0 0 0 2.542 2.542h87.572a2.54 2.54 0 0 0 2.542-2.542V2.543A2.543 2.543 0 0 0 98.094 0H10.522A2.54 2.54 0 0 0 7.98 2.543v12.103Z",
    fill: "#B06148"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M52.782 57.16h-3.177a1.78 1.78 0 0 0-1.779 1.78v58.305a1.757 1.757 0 0 0 1.1 1.629c.216.086.447.129.68.126h9.529a1.78 1.78 0 0 0 1.779-1.755V58.941a1.806 1.806 0 0 0-1.78-1.78h-6.352Z",
    fill: "#647F7F"
  })));
};

export default SvgPaintRoller;